import React, { useEffect, useState } from "react";
import { postModificarProcedimientoCirujanosCirugias, postProcedimientoVias } from "../../../services/PaginaRuta";
import ModalListaDeSeleccionEspcialidadProcedimientoDQ from "./ModalListaDeSeleccionEspcialidadProcedimientoDQ";
import ModalListaDeSeleccionMaestroDeProcedimientoDQ from "./ModalListaDeSeleccionMaestroDeProcedimientoDQ";
import ModalListaDeSeleccionMedicosProcedimientoDQ from "./ModalListaDeSeleccionMedicosProcedimientoDQ";
import ModalSeleccionHonorariosProcedimientoDQ from "./ModalSeleccionHonorariosProcedimientoDQ";

const ModalModificarCirujanosYCirugiasDQ = ({setmodalOnModificarCirujanosCirugias,item,passActualizarOtrosParticipantes}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataVias,setdataVias]=useState([])
    const [modalOnSeleccionMaestroProcedimiento, setmodalOnSeleccionMaestroProcedimiento]=useState(false)
    const [modalOnSeleccionMedicoEspecialista, setmodalOnSeleccionMedicoEspecialista]=useState(false)
    const [modalOnEspecialidadDelMedico, setmodalOnEspecialidadDelMedico]=useState(false)
    const [modalOnSeleccionHonorarios, setmodalOnSeleccionHonorarios]=useState(false)
    const [errorRealizada,seterrorRealizada]=useState('')
    const [isRealizada, setIsRealizada]=useState(false)
    const [viaUser, setviaUser]=useState('')
    const [passDataMaestroProcedimiento, setpassDataMaestroProcedimiento]=useState({
        codigoMaestro:'',
        nombreMaestro:''
      })
      const [passDataMedicoEspecialista, setpassDataMedicoEspecialista]=useState({
        codigoMedigo:'',
        nombreMedico:'',
        codigoEspecialidad:'',
        nombreEspecialidad:''
      })
      const [passDataHonorarios, setpassDataHonorarios]=useState({
        codigoHonorario:'',
        nombreHonorario:''
      })
      const [passDataEspecilidad, setpassDataEspecilidad]=useState({
        codigoEspecialidad:'',
        nombreEspecialidad:''
      })
      const handleOnclickSeleccionarHonorarios=()=>{
        setmodalOnSeleccionHonorarios(true)
      }
      const passDataHonorariosDX=(data)=>{
        setpassDataHonorarios(data)
        //console.log(data,'data honorarios')
        //seterrorHonorario('')
      }
      const handleOnclickEspecialidadMedico=()=>{
        setmodalOnEspecialidadDelMedico(true)
      }
      const passDataEspecialidadM=(data)=>{
        setpassDataEspecilidad(data)
        //console.log(data,'data especialidad')
        setpassDataMedicoEspecialista({
          codigoMedigo:passDataMedicoEspecialista.codigoMedigo,
          nombreMedico:passDataMedicoEspecialista.nombreMedico,
          codigoEspecialidad:data.codigoEspecialidad,
          nombreEspecialidad:data.nombreEspecialidad
        })
      }
      const passDataMedico=(data)=>{
        //console.log(data,'data medicooo')
        setpassDataMedicoEspecialista(data)
        //seterrorCirujano('')
      }
      const handleOnclickMedicosEspecialista=()=>{
        setmodalOnSeleccionMedicoEspecialista(true)
      }
      const passDataMaestro=(data)=>{
        setpassDataMaestroProcedimiento(data)
        //console.log(data,'passsssssssss')
        //seterrorCodigoProcedimiento('')
      }
      const handleOnclickMaestroProcedimiento=()=>{
        setmodalOnSeleccionMaestroProcedimiento(true)
      }
  const handleCancelarClick = () => {
    setmodalOnModificarCirujanosCirugias(false)
  };
  useEffect(()=>{
    //console.log(item,'itemmmmm ' )
    if(item.CrgEst == 'S'){
      setIsRealizada(true)
    }
    postProcedimientoVias().then((res)=>setdataVias(res.data))
    setpassDataMaestroProcedimiento({
        codigoMaestro:item.CrgCod,
        nombreMaestro:item.CrgDes
    })
    setpassDataMedicoEspecialista({
        codigoMedigo:item.MedCod,
        nombreMedico:item.MedNom,
        codigoEspecialidad:item.EspcCod,
        nombreEspecialidad:item.EspcDes
    })
    setpassDataHonorarios({
        codigoHonorario:item.CrgHnrCi,
        nombreHonorario:item.CrgHnCiD
    })
    setviaUser(item.ViaCod)
  },[])
  const handleOnsubmitModificar=(e)=>{
    e.preventDefault()
    const modificar={
      ProCirCod: item.ProCirCod,
      ProMCDpto:usuarioInfo.Sede,
      ProEmpCod: usuarioInfo.Empresa,
      CrgCod: e.target.codigoProcedimiento.value,
      CrgDes: e.target.proceNombre.value,
      ViaCod: e.target.viaP.value,
      MedCod: e.target.codigoCirujan.value,
      MedNom: e.target.nombremedico.value,
      EspcCod: e.target.codEspe.value,
      EspcDes: e.target.especialidadmedico.value,
      CrgHnCiD: e.target.nombrehonorario.value,
      CrgHnrCi: e.target.honoCodi.value,
      CrgEst: "S",
      CrgCnt: e.target.cantidad.value,
      CrgPrcCns: "1"
  }
  //console.log(modificar,'modiiiii')
  if(errorRealizada==''){
    postModificarProcedimientoCirujanosCirugias(modificar).then((res)=>{
      //console.log(res.data,'cirujanos modificar')
      setmodalOnModificarCirujanosCirugias(false)
      passActualizarOtrosParticipantes(modificar)
    })
  }
  

  }
  const handleOnchangeVia=(e)=>{
    setviaUser(e.target.value)
  }
  const handleOnchangeRealizada=()=>{
    setIsRealizada(!isRealizada)
    if(!isRealizada){
      seterrorRealizada('')
    }else{
      seterrorRealizada('Se debe seleccionar el estado Realizada, para continuar')
    }
  }
  //seterrorRealizada('Se debe seleccionar el estado Realizada, para continuar')
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)] max-w-7xl my-6 mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Modificar Cirugías y Cirujanos
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative p-1">
            <form onSubmit={handleOnsubmitModificar}>
              <div >
                <label className="form-label inline-block mb-2 text-gray-900 font-medium text-center text-2xl">
                Cirugías y Cirujanos
                </label>

                
                  <div className="flex-auto overflow-y-auto relative p-1">
                    <div className="flex flex-row   text-left">
                      <div className="w-1/3  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Codigo
                        </label>
                        <input
                          defaultValue={passDataMaestroProcedimiento.codigoMaestro }
                          type="text"
                          autoComplete="off"
                          disabled={true}
                          onClick={handleOnclickMaestroProcedimiento}
                          name="codigoProcedimiento"
                          //disabled={true}
                          //defaultValue={dataProcedimiento.ProCirCod}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                          {/* {errorCodigoProcedimiento} */}
                        </label>
                      </div>
                      <div className="w-1/3  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Procedimiento
                        </label>
                        <input
                          type="text"
                          disabled={true}
                          name='proceNombre'
                          defaultValue={passDataMaestroProcedimiento.nombreMaestro}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/3  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Cantidad
                        </label>
                        <input
                          //onChange={handleOnchangeCantidad}
                          defaultValue={item.CrgCnt}
                          autoComplete="off"
                          type="number"
                          name="cantidad"
                          //disabled={true}
                          //defaultValue={dataProcedimiento.MPTDoc}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                          {/* {errorCantidad} */}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex-auto overflow-y-auto relative p-1">
                    <div className="flex flex-row   text-left">
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Codigo Cirujano
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="codigoCirujan"
                          onFocus={handleOnclickMedicosEspecialista}
                          //disabled={true}
                          defaultValue={passDataMedicoEspecialista.codigoMedigo}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                          {/* {errorCirujano} */}
                        </label>
                      </div>

                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Cirujano
                        </label>
                        <input
                          type="text"
                          disabled={true}
                          name='nombremedico'
                          defaultValue={passDataMedicoEspecialista.nombreMedico}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Codigo Especialidad
                        </label>
                        <input
                          type="text"
                          //disabled={true}
                          name="codEspe"
                          onFocus={handleOnclickEspecialidadMedico}
                          defaultValue={passDataMedicoEspecialista.codigoEspecialidad}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/4  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Especialidad
                        </label>
                        <input
                          type="text"
                          //disabled={true}
                          name="especialidadmedico"
                          defaultValue={passDataMedicoEspecialista.nombreEspecialidad}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      
                    </div>
                  </div>
                  <div className="flex-auto overflow-y-auto relative p-1">
                    <div className="flex flex-row   text-left">
                      <div className="w-1/3  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Codigo Honorario
                        </label>
                        <input
                          name="honoCodi"
                          onFocus={handleOnclickSeleccionarHonorarios}
                          autoComplete="off"
                          defaultValue={passDataHonorarios.codigoHonorario}
                          type="text"
                          //disabled={true}
                          //defaultValue={dataProcedimiento.ProCirCod}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                          {/* {errorHonorario} */}
                        </label>
                      </div>
                      <div className="w-1/3  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Honorario
                        </label>
                        <input
                          type="text"
                          disabled={true}
                          name='nombrehonorario'
                          defaultValue={passDataHonorarios.nombreHonorario}
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                      <div className="w-1/3  px-1 ">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                          Via
                        </label>
                        <select
                          value={viaUser}
                          onChange={handleOnchangeVia}
                          name="viaP"
                          className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          aria-label="Default select example"
                        >
                          {dataVias.map((item) => (
                            <option value={item.ViaCod} key={item.ViaCod}>
                              {item.ViaDsc}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="flex-auto overflow-y-auto relative px-4">
                    <div className="flex flex-row py-2  text-left">
                      <div className="w-1/3 px-4">
                        <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                          Realizada?
                        </label>
                        <input
                          onChange={handleOnchangeRealizada}
                          checked={isRealizada}
                          className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                          type="checkbox"
                          name="valoracionPreanestesica"
                          id="flexCheckDefault"
                          //checked={reqValoracionPreanestesica}
                          //onChange={handleOnchangeReqValoracionPreanestesica}
                        />

                        {/* <div className="inline-block px-8">
                          <button
                            type="submit"
                            //onClick={handleClickDataCirugia}
                            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                          >
                            Agregar
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="text-left px-6">
                    <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorRealizada}
                    </label>
                  </div>
                
              </div>
              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  //onClick={handleOnsubmitModificar}
                  type="submit"
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Modificar
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
      {modalOnSeleccionMaestroProcedimiento? <ModalListaDeSeleccionMaestroDeProcedimientoDQ setmodalOnSeleccionMaestroProcedimiento={setmodalOnSeleccionMaestroProcedimiento} passDataMaestro={passDataMaestro}/>:null}
      {modalOnSeleccionMedicoEspecialista? <ModalListaDeSeleccionMedicosProcedimientoDQ setmodalOnSeleccionMedicoEspecialista={setmodalOnSeleccionMedicoEspecialista} passDataMedico={passDataMedico}/>:null}
      {modalOnEspecialidadDelMedico? <ModalListaDeSeleccionEspcialidadProcedimientoDQ setmodalOnEspecialidadDelMedico={setmodalOnEspecialidadDelMedico} passDataMedicoEspecialista={passDataMedicoEspecialista} passDataEspecialidadM={passDataEspecialidadM}/>:null}
      {modalOnSeleccionHonorarios? <ModalSeleccionHonorariosProcedimientoDQ setmodalOnSeleccionHonorarios={setmodalOnSeleccionHonorarios} passDataHonorariosDX={passDataHonorariosDX}/>:null}
    </>
  );
};

export default ModalModificarCirujanosYCirugiasDQ;
